import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';

var bnr = require('./../../images/background/footerbg.webp');

class Footer2 extends React.Component {
    render() {

        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper bg-cover" style={{backgroundImage:"url(" + bnr + ")"}}>
                        <div className="overlay-main sx-bg-secondry opacity-08" />
                        <div className="container">
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="widget widget_about">
                                        {/*<h4 class="widget-title">About Company</h4>*/}
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"./"}>
                                                <img src={require('./../../images/aw-logo.png')} alt="Group4"  />
                                            </NavLink>
                                        </div><br/>
                                        <p>ATELIER is your destination for luxury bathrooms, kitchens, wellness, surfaces, and interiors. Bringing the world’s best brands under one roof.</p>
                                        <ul className="social-icons  sx-social-links" >
                                            {/* <li><a href="https://www.behance.net/" className="fa fa-behance" target="_blank"></a></li> */}
                                            <li><a href="https://www.facebook.com/AbsoluteAtelier" className="fa fa-facebook" target="_blank"></a></li>
                                            {/* <li><a href="https://twitter.com" className="fa fa-twitter" target="_blank"></a></li> */}
                                            <li><a href="https://www.instagram.com/atelier_dz/" className="fa fa-instagram" target="_blank"></a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* RESENT POST */}
                                {/* <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget recent-posts-entry-date">
                                        <h5 className="widget-title">Latest Updates</h5>
                                        <div className="widget-post-bx">
                                            <div className="widget-post clearfix">
                                                <div className="sx-post-date text-center text-uppercase text-white">
                                                    <strong className="p-date">15</strong>
                                                    <span className="p-month">Sep</span>
                                                    <span className="p-year">2025</span>
                                                </div>
                                                <div className="sx-post-info">
                                                    <div className="sx-post-header">
                                                        <h6 className="post-title"><NavLink to={"/blog-single"}>New Collection Launch</NavLink></h6>
                                                    </div>
                                                    <div className="sx-post-meta">
                                                        <ul>
                                                            <li className="post-author"><i className="fa fa-user" />By Admin</li>
                                                            <li className="post-comment"><i className="fa fa-comments" /> 28</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="widget-post clearfix">
                                                <div className="sx-post-date text-center text-uppercase text-white">
                                                    <strong className="p-date">17</strong>
                                                    <span className="p-month">Aug</span>
                                                    <span className="p-year">2025</span>
                                                </div>
                                                <div className="sx-post-info">
                                                    <div className="sx-post-header">
                                                        <h6 className="post-title"><NavLink to={"/blog-single"}>Wellness Interiors Showcase</NavLink></h6>
                                                    </div>
                                                    <div className="sx-post-meta">
                                                        <ul>
                                                            <li className="post-author"><i className="fa fa-user" />By Admin</li>
                                                            <li className="post-comment"><i className="fa fa-comments" /> 29</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div> */}
                                {/* USEFUL LINKS */}
                                <div className="col-lg-3 col-md-6 col-sm-12 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">Browse</h5>
                                        <ul>
                                            <li><NavLink to={"/"}>Home</NavLink></li>
                                            <li><NavLink to={"/about-us"}>About us</NavLink></li>
                                            <li><NavLink to={"/products"}>Products</NavLink></li>
                                            <li><NavLink to={"/brands"}>Brands</NavLink></li>
                                            <li><NavLink to={"/contact-us"}>Contact Us</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* CONTACT US */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h5 className="widget-title">Let’s Talk</h5>
                                        <ul className="widget_address">
                                            <li>Atelier Designs, Fr. Muller Road, Valencia, Mangalore, India - 575 002</li>
                                            <li>info@atelierdz.com </li>
                                            <li>+91 72040 97368</li>
                                            {/* <li>+91 959 189 0009</li> */}
                                            <li>+91 80504 81583</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="call-to-action-wrap">
                                <div className="row">
                                    {/* <div className="col-lg-7 col-md-6">
                                        <div className="call-to-action-left">
                                            <h5 className="text-uppercase m-b10 m-t0">Subscribe to our newsletter!</h5>
                                            <span>Never Miss Anything From ATELIER By Signing Up To Our Newsletter.</span>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-5 col-md-6">
                                        <div className="call-to-action-right">
                                            <div className="widget_newsletter">
                                                <div className="newsletter-bx">
                                                    <form role="search" method="post" action="">
                                                        <div className="input-group">
                                                            <input name="news-letter" className="form-control" placeholder="ENTER YOUR EMAIL" type="text" />
                                                            <span className="input-group-btn">
                                                                <button type="button" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                   <div className="footer-bottom overlay-wraper">
    <div className="overlay-main" />
    <div className="container">
        <div className="row">
            <div className="sx-footer-bot-left">
                <span className="copyrights-text">
                    © 2025 ATELIER. Designed By{" "}
                    <a 
                        href="https://brightmedia.tech" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{
                            color: '#fff',
                            textDecoration: 'underline',
                            cursor: 'pointer'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.8'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                        BRIGHT MEDIA.tech
                    </a>
                </span>
            </div>
        </div>
    </div>
</div>
                </footer>
                <Switcher />
            </>
        );
    };
};

export default Footer2;